import { requestType } from '~/config/enum.config';
var SERVICE = 'domain-service';
var CONTROLLER = 'caseVerifyRecordController';
export default {
    /**
     * 获取核销案件信息
     */
    getAllVerifyInfos: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getAllVerifyInfos',
        type: requestType.Get
    },
    /**
     * 核销案件
     */
    verifiedCaseInfo: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'verifiedCaseInfo',
        type: requestType.Post
    },
    /**
     * 核销案件上传附件
     */
    uploadCaseVerifyFile: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'uploadCaseVerifyFile',
        type: requestType.Post
    },
    /**
     * 核销案件上传附件
     */
    exportVerifyInfos: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'exportVerifyInfos',
        type: requestType.Get
    },
};
